import { createElementVNode as _createElementVNode, openBlock as _openBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13926f5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 32 32" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "16",
    cy: "16",
    r: "16"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M24 8L8 24",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 8L24 24",
    "stroke-linecap": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), {
    "aria-label": _ctx.$t('global.close'),
    type: _ctx.type === 'button' ? _ctx.type : false,
    to: _ctx.to,
    class: _normalizeClass(['btn-close', 'btn-close--' + _ctx.variant, _ctx.size ? 'btn-close--size-' + _ctx.size : ''])
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["aria-label", "type", "to", "class"]))
}